export default __webpack_public_path__ + "static/media/(3).0da720f0.png";